import { useTranslation } from "react-i18next";
import { AlertTriangle, Check } from "lucide-react";
import { PlanResult } from "../models/PlanResult";

interface PlanResultSummaryProps {
  result: PlanResult;
}

/** Per-action outcome of a confirmed plan — partial failures stay visible. */
export function PlanResultSummary({ result }: PlanResultSummaryProps) {
  const { t } = useTranslation();

  return (
    <div className="with-border rounded-2xl p-4 lg:p-6">
      <h2 className="text-lg font-semibold leading-tight">
        {result.failedCount === 0
          ? t("assistant.result.allApplied")
          : t("assistant.result.partiallyApplied", { count: result.failedCount })}
      </h2>
      <ul className="mt-2 space-y-1">
        {result.items.map((item) => (
          <li key={item.tempId} className="flex items-start gap-2 text-sm">
            {item.error === null ? (
              <Check size={16} className="mt-0.5 shrink-0 text-green-700 dark:text-green-400" />
            ) : (
              <AlertTriangle size={16} className="mt-0.5 shrink-0 text-red-700 dark:text-red-400" />
            )}
            <span>
              {item.label}
              {item.error !== null && (
                <span className="text-red-700 dark:text-red-400"> — {item.error}</span>
              )}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
